import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import { withRouter } from 'react-router-dom';
import moment from 'moment';
import Fa from 'react-fontawesome';
import ReactResizeDetector from 'react-resize-detector';
import { cloneDeep, filter, reduce, each, uniq, delay } from 'lodash';
import { Tab, Tabs, Nav, NavItem } from 'react-bootstrap';
import ProgressBar from '../../../../components/progress-bar';
import SearchForm from '../../../../components/search-form';
import PeriodField from '../../../Forecast/components/period-field/period-field';
import { fetchForcastPeriods } from '../../../Forecast/ForecastActions';
import PipelineDateDropdown from '../../../Pipeline/components/pipeline-date-dropdown';
import NumberDisplay from '../../../../components/number-display';
// Import Selectors
import { getForcastPeriods } from '../../../Forecast/ForecastReducer';
import CurrentStats from '../../components/CurrentStats';
import {
  resetAll,
  fetchPipelineOppotunities,
  fetchForecastOppotunities,
  fetchConversionOpportunities,
  fetchCurrentGlobalRankings,
} from '../../DashboardActions';
import { getUser, getUserCurrentOrganization } from '../../../Auth/AuthReducer';
import { getHeaderHeight } from '../../../App/AppReducer';
import { getAccountIndustryFilter } from '../../../../components/search-form/search-form-reducer';

import {
  getPipelineLoading, getPipelineLoaded,
  getPipelineOpportunities, getPipelineAccounts,
  getForecastOpportunities,
  getShouldShowAllStats,
} from '../../DashboardReducer';
import RequestFeedbackManager from '../../../../components/request-feedback-manager';


import OpportunityTable from '../../components/OpportunityTable';
import OpportunityModal from '../../components/OpportunityTable/modal';
import AccountTable from '../../components/AccountTable';
import styles from './styles.css';

const USER_PREFERENCE_PIPELINE_SINCE = 'dashboard-pipeline-since';

const DATE_FORMAT = 'YYYY-MM-DD';

class DashboardCurrentPage extends Component {
  constructor(props) {
    super(props);
    const periodStart = moment().startOf('month').format(DATE_FORMAT);
    const periodEnd = moment().endOf('month').format(DATE_FORMAT);
    this.state = {
      loadingPeriods: true,
      periodStart,
      periodEnd,
      selectedPipelineSinceDisplay: null,
      selectedPeriodDisplay: cloneDeep([periodStart, periodEnd]),
      selectedPipelineSince: null,
      selectedTab: 'opportunities',
      selectedOpportunityIds: [],
      selectedOpportunityFunc: null,
      fullScreenMode: false,
      navHeight: 0,
    };

    this.handleFormChange = this.handleFormChange.bind(this);
    this.hanldeReset = this.hanldeReset.bind(this);
    this.handleUpdatePipelineSince = this.handleUpdatePipelineSince.bind(this);
    this.onTabSelect = this.onTabSelect.bind(this);
    this.handleStatsSelectOpportunities = this.handleStatsSelectOpportunities.bind(this);
    this.handleOnEnterFullScreen = this.handleOnEnterFullScreen.bind(this);
    this.handleOnExitFullScreen = this.handleOnExitFullScreen.bind(this);
    this.onResizeTabs = this.onResizeTabs.bind(this);
    this.hanldeSearchContextChange = this.hanldeSearchContextChange.bind(this);
  }

  componentWillMount() {
    const { getUserPreference } = this.context;
    const selectedPipelineSince = getUserPreference(USER_PREFERENCE_PIPELINE_SINCE, 'last-month', true);
    this.setState({
      selectedPipelineSince,
    });
  }

  componentDidMount() {
    this.props.dispatch(fetchForcastPeriods())
      .then(() => {
        this.setState({ loadingPeriods: false });
      });
  }

  onTabSelect(selectedTab) {
    this.setState({ selectedTab });
  }

  onResizeTabs(width, navHeight) {
    this.setState({ navHeight });
  }

  hanldeSearchContextChange(params) {
    const state = {};
    if (params.selectedPipelineSince) {
      state.selectedPipelineSince = params.selectedPipelineSince;
    }
    if (params.periodStart && params.periodEnd) {
      const start = moment(params.periodStart, DATE_FORMAT);
      const end = moment(params.periodEnd, DATE_FORMAT);
      if (start.isValid() && end.isValid()) {
        state.periodStart = params.periodStart;
        state.periodEnd = params.periodEnd;
      }
    }
    if (!state.periodStart || !state.periodEnd) {
      state.periodStart = moment().startOf('month').format(DATE_FORMAT);
      state.periodEnd = moment().endOf('month').format(DATE_FORMAT);
    }
    state.selectedPeriodDisplay = cloneDeep([state.periodStart, state.periodEnd]);
    this.setState(state);
  }

  handleFormChange(criteria) {
    const { selectedPipelineSince } = this.state;
    const { query } = criteria;

    const selectedPipelineSinceDisplay = this.state.selectedPipelineSince;
    const selectedPeriodDisplay = cloneDeep([this.state.periodStart, this.state.periodEnd]);
  
    this.setState({ selectedPeriodDisplay, selectedPipelineSinceDisplay });
    this.props.dispatch(resetAll(false))
      .then(() => {
        this.props.dispatch(fetchPipelineOppotunities({
          ...criteria,
          pipeline: selectedPipelineSince,
        }, this.props.industries))
          .then((results) => {
            const { opportunities, total } = results;
            const returnResults = opportunities.length;
            if (total && returnResults < total) {
              const el = (
                <div>
                  Your search return more than <NumberDisplay value={total} precision={0} /> results.<br />
                  For optimal performance, only the latest <NumberDisplay value={returnResults} precision={0} /> will be displayed.
                </div>
              );
              this.context.addNotification(el, { type: 'warning', autoClose: 30 * 1000 });
            }
            this.props.dispatch(fetchConversionOpportunities({ query, team: criteria.team }));
          });
        this.props.dispatch(fetchForecastOppotunities({
          ...criteria,
        }))
          .then(
            () => {
              delay(() => {
                this.props.dispatch(fetchCurrentGlobalRankings({
                  ...criteria,
                  pipeline: selectedPipelineSince,
                  period: [this.state.periodStart, this.state.periodEnd],
                }));
              }, 500);
            },
          );
      });
  }

  hanldeReset() {
    this.props.dispatch(resetAll());
  }
  handleOnEnterFullScreen() {
    this.setState({ fullScreenMode: true });
  }
  handleOnExitFullScreen() {
    this.setState({ fullScreenMode: false });
  }

  handleStatsSelectOpportunities(selectedOpportunityIds, type) {
    let selectedOpportunityFunc = null;
    if (type === 'forecast') {
      selectedOpportunityFunc = getForecastOpportunities;
    } else if (type === 'pipeline') {
      selectedOpportunityFunc = getPipelineOpportunities;
    }
    this.setState({ selectedOpportunityIds, selectedOpportunityFunc });
  }

  handleUpdatePipelineSince(option) {
    const { value } = option;
    if (value) {
      this.setState({
        selectedPipelineSince: value,
      });
      this.context.updateUserPreference(USER_PREFERENCE_PIPELINE_SINCE, value, true);
    }
  }

  renderFullScreenTabs() {
    const { siteHeaderHeight } = this.props;
    return [
      (
        <div
          className={`${styles.fullScreenTabs} animated fadeIn`}
          style={{ top: siteHeaderHeight }}
          key="tabs"
        >
          <Nav
            bsStyle="pills"
            activeKey={this.state.selectedTab}
            onSelect={this.onTabSelect}
          >
            <NavItem eventKey="opportunities">
              Opportunities
            </NavItem>
            <NavItem eventKey="accounts">
              Accounts
            </NavItem>
          </Nav>
          <ReactResizeDetector handleHeight onResize={this.onResizeTabs} />
        </div>
      ),
      (
        <div className={`${styles.fullScreenMask} animated fadeIn`} />
      ),
    ];
  }

  renderTabs() {
    const {
      pipelineOpportunities, pipelineAccounts, auth, shouldShowAllStats,
    } = this.props;
    const { fullScreenMode, navHeight } = this.state;
    const opportunities = shouldShowAllStats ? pipelineOpportunities : filter(pipelineOpportunities, { owner_id: auth.user_id });
    const accounts = shouldShowAllStats ? pipelineAccounts : filter(pipelineAccounts, { owner_id: auth.user_id });
    return (
      <div>
        {fullScreenMode && this.renderFullScreenTabs()}
        <Tabs
          defaultActiveKey={this.state.selectedTab}
          activeKey={this.state.selectedTab}
          id="dashboard-sub-tabs"
          animation
          mountOnEnter
          onSelect={this.onTabSelect}
        >
          <Tab
            eventKey="opportunities"
            title="Opportunities"
          >
            <div className={styles.tabContent}>
              <OpportunityTable
                tableName="dashboard-opportunities"
                opportunities={opportunities}
                isManager={shouldShowAllStats}
                onEnterFullScreen={this.handleOnEnterFullScreen}
                onExitFullScreen={this.handleOnExitFullScreen}
                fullScreenMode={fullScreenMode}
                fullScreenOffset={{ y: navHeight }}
              />
            </div>
          </Tab>
          <Tab
            eventKey="accounts"
            title="Accounts"
          >
            <div className={styles.tabContent}>
              <AccountTable
                accounts={accounts}
                isManager={shouldShowAllStats}
                onEnterFullScreen={this.handleOnEnterFullScreen}
                onExitFullScreen={this.handleOnExitFullScreen}
                fullScreenMode={fullScreenMode}
                fullScreenOffset={{ y: navHeight }}
              />
            </div>
          </Tab>
        </Tabs>
        <OpportunityModal
          opportunityIds={this.state.selectedOpportunityIds}
          getOpportunities={this.state.selectedOpportunityFunc}
          tableConfigs={{
            isManager: shouldShowAllStats,
            tableName: 'dashboard-modal-opportunities',
          }}
          onClose={() => {
            this.setState({ selectedOpportunityIds: [], selectedOpportunityFunc: null });
          }}
        />
        <RequestFeedbackManager />
      </div>
    );
  }

  render() {
    const {
      periods, pipelineLoading,
      pipelineLoaded,
      shouldShowAllStats,
    } = this.props;
    const {
      loadingPeriods,
      selectedPipelineSince,
    } = this.state;

    const isLoading = pipelineLoading || !pipelineLoaded;

    const childrenNodes = [];
    if (!loadingPeriods) {
      childrenNodes.push((
        <div key="pipleine">
          <PipelineDateDropdown
            pipelineSince={selectedPipelineSince}
            onUpdate={this.handleUpdatePipelineSince}
          />
        </div>
      ));
      childrenNodes.push((
        <div key="period" style={{ paddingTop: '10px' }}>
          <PeriodField
            periods={periods}
            path={1}
            level={1}
            showDelete={false}
            showInclude={false}
            searchCriteria={{
              _id: 'forecast-period',
              type: 'include',
              filter: {
                _id: 'forecast-period-filter',
                label: 'Forecast Period',
              },
            }}
            values={[this.state.periodStart, this.state.periodEnd]}
            onChange={([periodStart, periodEnd]) => { this.setState({ periodStart, periodEnd }); }}
          />
        </div>
      ));
    }

    return (
      <div>
        <Helmet title="Dashboard | Current" />
        <div className="container">
          <div className="clearfix">
            <div className="pull-right">
              {loadingPeriods && <Fa name="spinner" spin />}
              {!loadingPeriods &&
                <SearchForm
                  onSearchChange={this.handleFormChange}
                  onReset={this.hanldeReset}
                  pullRight
                  requireTeamSelector
                  defaultCriteria={{
                    type: 'groupAND',
                    values: [],
                  }}
                  type="dashboard/current"
                  queryParams={{ forecast: true, period: [this.state.periodStart, this.state.periodEnd], dashboard: true }}
                  disabledFilters={[]}
                  searchContext={{
                    selectedPipelineSince,
                    periodStart: this.state.periodStart,
                    periodEnd: this.state.periodEnd,
                  }}
                  onSearchContextChange={this.hanldeSearchContextChange}
                >
                  {childrenNodes}
                </SearchForm>
              }
            </div>
          </div>
          <p />
          <div>
            <CurrentStats
              pipelineSince={this.state.selectedPipelineSinceDisplay}
              period={this.state.selectedPeriodDisplay}
              shouldShowAllStats={shouldShowAllStats}
              handleSelectOpportunities={this.handleStatsSelectOpportunities}
            />
          </div>
          {isLoading && <ProgressBar />}
          {!isLoading && this.renderTabs()}

        </div>
      </div>
    );
  }
}

// Retrieve data from store as props
function mapStateToProps(state) {
  const auth = getUser(state);
  const organization = getUserCurrentOrganization(state);
  const pipelineOpportunities = filter(getPipelineOpportunities(state), { is_closed: false });
  const pipelineAccounts = getPipelineAccounts(state);

  const accountIndustryFilter = getAccountIndustryFilter(state);
  const accountIndustryMappings = accountIndustryFilter ? accountIndustryFilter.mappings : [];
  const accountIndustryValues = accountIndustryFilter ? accountIndustryFilter.values : [];
  const hasIndustryMappings = (filter(accountIndustryMappings, m => m.values.length > 0)).length > 0;
  let categories = [];
  if (hasIndustryMappings) {
    categories = reduce(accountIndustryMappings, (items, mapping) => items.concat({
      id: mapping._id,
      label: mapping.label,
      values: mapping.values,
    }), []);
  } else {
    categories = reduce(accountIndustryValues, (items, val) => items.concat({
      id: val._id,
      label: val.label,
      values: [val.industry_id],
    }), []);
  }
  const reverseMappings = reduce(categories, (items, category) => {
    each(category.values, (value) => {
      if (!items[value]) {
        items[value] = [];
      }
      items[value] = uniq(items[value].concat(category.label));
    });
    return items;
  }, {});

  return {
    periods: getForcastPeriods(state),
    pipelineLoading: getPipelineLoading(state),
    pipelineLoaded: getPipelineLoaded(state),
    pipelineOpportunities,
    pipelineAccounts,
    auth,
    industries: reverseMappings,
    siteHeaderHeight: getHeaderHeight(state),
    shouldShowAllStats: getShouldShowAllStats(null, auth, organization, 'workspace'),
  };
}

DashboardCurrentPage.propTypes = {
  dispatch: PropTypes.func.isRequired,
  periods: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  pipelineLoading: PropTypes.bool,
  pipelineLoaded: PropTypes.bool,
  pipelineOpportunities: PropTypes.arrayOf(PropTypes.shape({})),
  pipelineAccounts: PropTypes.arrayOf(PropTypes.shape({})),
  auth: PropTypes.shape({}),
  industries: PropTypes.shape({}),
  siteHeaderHeight: PropTypes.number,
  shouldShowAllStats: PropTypes.bool,

};
DashboardCurrentPage.defaultProps = {
  pipelineLoading: false,
  pipelineLoaded: false,
  pipelineOpportunities: [],
  pipelineAccounts: [],
  auth: null,
  industries: {},
  siteHeaderHeight: 0,
  shouldShowAllStats: false,
};

DashboardCurrentPage.contextTypes = {
  router: PropTypes.shape({}),
  addNotification: PropTypes.func.isRequired,
  updateUserPreference: PropTypes.func.isRequired,
  getUserPreference: PropTypes.func.isRequired,
};
export default connect(mapStateToProps)(withRouter(DashboardCurrentPage));
